import { render, staticRenderFns } from "./access-registration.vue?vue&type=template&id=0dd3cc21&scoped=true&lang=pug&"
import script from "./access-registration.vue?vue&type=script&lang=js&"
export * from "./access-registration.vue?vue&type=script&lang=js&"
import style0 from "./access-registration.vue?vue&type=style&index=0&id=0dd3cc21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd3cc21",
  null
  
)

export default component.exports